export default function getSuperAdminSitesReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_SUPER_ADMIN_SITES_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_SUPER_ADMIN_SITES_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_SUPER_ADMIN_SITES_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}